import { Spinner, Typography } from '../../../shared';

const ProcessingPendingState = () => {
  return (
    <div className="flex h-32 flex-col items-center justify-center gap-6">
      <Spinner />
      <Typography>Building AI twin...</Typography>
    </div>
  );
};

export default ProcessingPendingState;
